<template>
  <md-table v-model="tableData" table-header-color="green">
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell :md-label="$lang.general.test_value">{{ testCaseName(item.testCase) }}</md-table-cell>
      <md-table-cell :md-label="$lang.charts.phase">{{ testCasePhase(item.testCase) }}</md-table-cell>

      <md-table-cell :md-label="$lang.titles.generator">{{ item.generator_value }} {{testCaseUnit(item.testCase)}}</md-table-cell>
      <md-table-cell :md-label="$lang.general.device">{{ item.device_value }} {{testCaseUnit(item.testCase)}}</md-table-cell>

      <md-table-cell :md-label="$lang.general.absolute_error">
        <md-icon v-if="item.absolute_error > 0" class="text-warning">arrow_drop_up</md-icon>
        <md-icon v-if="item.absolute_error == 0" class="text-success">remove</md-icon>
        <md-icon v-if="item.absolute_error < 0" class="text-info">arrow_drop_down</md-icon>
        {{item.absolute_error}} {{testCaseUnit(item.testCase)}}
      </md-table-cell>
      <md-table-cell :md-label="$lang.general.relative_error">
        <md-icon v-if="item.status == 'SUCCESS'" class="text-success">check</md-icon>
        <md-icon v-else class="text-danger">close</md-icon>
        {{ item.relative_error }} %
      </md-table-cell>
    </md-table-row>
  </md-table>
</template>

<script>
export default {
  name: "test-case-table",
  props: {
    tableData: Array
  },
  data() {
    return {};
  },

  methods: {
    testCaseName(testCaseKey) {
      switch (testCaseKey.charAt(0)) {
        case "V":
          return this.$lang.menu.voltage;
        case "I":
          return this.$lang.menu.current;
        case "P":
          return this.$lang.menu.active_power;
        case "Q":
          return this.$lang.menu.reactive_power;
        case "S":
          return this.$lang.menu.apparent_power;
        default:
          return "";
      }
    },

    testCasePhase(testCaseKey) {
      switch (testCaseKey.charAt(1)) {
        case "A":
          return "L1";
        case "B":
          return "L2";
        case "C":
          return "L3";
        default:
          return "";
      }
    },

    testCaseUnit(testCaseKey) {
      switch (testCaseKey.charAt(0)) {
        case "V":
          return "V";
        case "I":
          return "A";
        case "P":
          return "W";
        case "Q":
          return "VAr";
        case "S":
          return "VA";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
.md-table {
  width: 100%;
}
</style>